import { createContext, useContext } from "react";
import { MutationCallbacks } from "@/dataProvider/types";
import { EncryptionRuleDataTypeMappingResponseDto, UpdateFieldGovernanceInput } from "@/gen/api/governance";
import { DataTypeMaskingKind } from "./maskingRuleDataTypesMap";


export interface FieldEditControllerProps {
  save: (x:UpdateFieldGovernanceInput, callbacks: MutationCallbacks) => void,
  encryptRules: EncryptionRuleDataTypeMappingResponseDto[],
  maskingKind: DataTypeMaskingKind,
  mode: 'single'|'bulk'
}

export const FieldEditContext = createContext<FieldEditControllerProps>({
  save: () => {},
  encryptRules: [],
  maskingKind: 'not_support',
  mode: 'single',
})

export const useFieldEditContext = () => useContext(FieldEditContext);

